import { Avatar } from './avatar';

export interface Attachment {
  id: string;
  userId: string;
  partnerId: string;
  filename: string;
  filesize: number;
  mime: string | null;
  createdAt: string;
  s3Ref: AttachmentS3Ref;
  user: AttachmentUser;
}

export interface AttachmentS3Ref {
  key: string;
  bucket: string;
  etag: string;
  orderId: string;
}

export interface AttachmentUser {
  id: string;
  name: string;
  email: string;
  avatar: Avatar;
  createdAt: string;
  updatedAt: string | null;
}
